import { Typography } from 'antd';
import React from 'react';
const { Title , Paragraph } = Typography;

const WorkingTitle = () => {
    return (
        <>
            <div style={{ padding: '5rem 0', textAlign: 'center', backgroundColor: '#112240' }}>
                <Title level={3} style={{ color: '#FFF' }}>Working || Freelancing</Title>
                <Paragraph level={5} style={{ color: '#FFF'  , textTransform:'uppercase'}}>"You will do foolish things, but do them with enthusiasm</Paragraph>
            </div>
        </>
    );
};

export default WorkingTitle;